export interface TSConfig {
  env: string;
  backendURL: string;
  baseName: string;
  cdn_url: string;
  googleAPIKey: string;
  image_placeholder_url: string;
  jetpackAPIUrl: string;
  jetpackBackendUrl: string;
  jetpackFrontendUrl: string;
  publicURL: string;
  s3BucketURL: string;
  s3LogosDirectory: string;
  s3QRCodesDirectory: string;
  s3SVGFlyersDirectory: string;
  saasBackendUrl: string;
  sentryDSN: string;
  staticURL: string;
  stripePublicKey: string;
  v1URL: string;
  wheelV2GameUrl: string;
}

// global configuration variable loaded via a <style> tag in index.html
// @ts-ignore
const CONFIG: TSConfig = TS_CONFIG;
export default CONFIG;
